export default "__VITE_ASSET__VQU8EtOZ__"